module.exports = __webpack_public_path__ + "static/media/cockroach(14).7b953272.PNG";